<template>
  <el-col :span="24" class="zfMsg-list-wrap" v-if="zfLists.length < 1">
    <el-empty
      :image-size="100"
      :description="
        zfMsgFormJifen >= 720 || zfMsgFormVip > 0
          ? '送一段最难忘的祝福语'
          : '订晚报 换积分 送祝福'
      "
    >
      <div
        class="zfMsg-items-btn"
        v-if="zfMsgFormJifen >= 720 || zfMsgFormVip > 0"
      >
        <el-button @click="sendZf">送祝福</el-button>
      </div>
    </el-empty>
  </el-col>
  <el-col :span="24" class="zfMsg-list-wrap" v-else>
    <div class="listItems">
      <div
        class="zfMsg-list-items"
        v-for="(item, key) in zfLists"
        :key="key"
        :data-id="key"
        @click="showZfOrderId(key)"
      >
        <div>
          <p class="msg-type">{{ item.wish_type }}（{{ item.news_date }}）</p>
          <p
            class="msg-status"
            style="color: var(--zfMsg-process)"
            v-if="item.status == 1"
          >
            待审核
          </p>
          <p
            class="msg-status"
            style="color: var(--zfMsg-process-complate)"
            v-if="item.status == 2"
          >
            审核通过
          </p>
          <p
            class="msg-status"
            style="color: var(--zfMsg-back)"
            v-if="item.status == 3"
          >
            审核退回
          </p>
          <p
            class="msg-status"
            style="color: var(--zfMsg-publish)"
            v-if="item.status == 4"
          >
            登报刊发
          </p>
        </div>
      </div>
    </div>
  </el-col>
</template>

<script>
export default {
  name: "ZfList",
  props: {
    sendZf: Function,
    showZfOrderId: Function,
    zfLists: Array,
    zfMsgFormJifen: Number,
    zfMsgFormCount: Number,
    zfMsgFormVip: Number,
  },
};
</script>

<style scoped>
.zfMsg-list-wrap button,
.zfMsg-list-wrap .el-button:focus,
.zfMsg-list-wrap .el-button:hover {
  color: var(--fff);
  background-color: var(--equity-header-btn-color);
}

.listItems {
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-top: 0;
}

.zfMsg-list-wrap .zfMsg-list-items div {
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--ccc);
  border-radius: 10px;
  margin-bottom: 10px;
  padding: 10px;
}

.zfMsg-list-wrap .zfMsg-list-items:last-child div {
  margin-bottom: 0;
}

.msg-type {
  flex: 1;
  text-align: left;
  padding-right: 10px;
  color: var(--zfMsg-text);
}
</style>